<div class="walk-form-container"> 

    <div class="select-container">
        <mat-label>{{'routeForm.yourStepWillBe' | transloco}}</mat-label>
        <mat-form-field> 
            <mat-select [value]="walkSpeed()" (valueChange)="walkSpeed.set($event)" name="walkSpeed">
                <mat-option *ngFor="let wSpeed of walkSpeedOptions" [value]="wSpeed">
                {{(wSpeed.label) | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="check-container">
        <mat-checkbox [checked]="wheelchairAccessible()" (change)="wheelchairAccessible.set($event.checked)" color="primary"></mat-checkbox>
        <mat-label>{{'routeForm.wheelchairAccessibleRoute' | transloco}}</mat-label>
    </div>
</div>